import styled from "styled-components";

type ContainerProps = {
  borderColor?: string;
  overlay?: boolean;
  disabled?: boolean;
}

export const Container = styled.div<ContainerProps>`
  border-left: 4px solid ${({ borderColor }) => borderColor} !important;
  opacity: ${({ overlay }) => overlay ? 0.5 : 1};
  display: flex;
  flex-direction: column;
  padding: 8px 8px 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  border-radius: 5px;
  background-color: white;
  margin-bottom: 6px;
  cursor: grab;

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  .singleImgContainer {
    position: relative;
    width: 100%;
    height: 96px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    border-radius: 4px;
    margin-bottom: 12px;
    overflow: hidden;
    cursor: zoom-in;

    .img {
      width: 260px;
      min-width: 260px;
      max-width: 260px;
      height: 96px;
      min-height: 96px;
      max-height: 96px;
      border-radius: 4px;
      object-fit: contain;
    }
  }

  .multipleImgContainer {
    position: relative;
    width: 100%;
    height: 96px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    border-radius: 4px;
    margin-bottom: 12px;
    overflow: hidden;
    cursor: zoom-in;

    .img {
      width: 50%;
      height: 96px;
      object-fit: contain;
    }

    .imgCount {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #000;
      opacity: 0.3;
      pointer-events: none;

      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.07px;
        color: #fff;
      }
    }
  }

  .cardHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .cardHeaderLeft {
      display: flex;
      align-items: center;

      .cardTextHeader {
        font-size: 12px;
        line-height: 16.34px;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      }
      
      .cardIconHeader {
        margin-left: 12px;
      }
    }

    .cardHeaderRight {
      display: flex;
      align-items: center;

      .cardCommentContainer {
        display: flex;
        align-items: center;

        .cardCommentIcon {
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
        }

        .cardCommentText {
          font-size: 12px;
          line-height: 100%;
          font-weight: 400;
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        }
      }

      .cardIconAlarm {
        color: ${({ theme }) => theme.colors.danger.danger} !important;
        margin-left: 6px;
        cursor: pointer;
      }
    }
  }

  .cardTitleText {
    font-size: 14px;
    line-height: 19.07px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    padding-top: 4px;
    word-wrap: break-word;
  }

  .cardAvatars {
    display: flex;
    align-items: center;
    padding-top: 12px;
  }

  .cardDisciplinesWrapper {
    display: flex;
    flex-wrap: wrap;
    padding-top: 12px;

    .cardDiscipline {
      display: flex;
      align-items: center;
      padding-right: 8px;

      .cardDisciplineIcon {
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      }

      .cardDisciplineText {
        font-size: 12px;
        line-height: 16.34px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.surface.onSurface};
        padding-left: 2px;
      }
    }
  }

  .cardDate {
    display: flex;
    align-items: center;
    padding-top: 12px;

    .cardDateText {
      font-size: 12px;
      line-height: 16.34px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      padding-left: 2px;
    }

    .cardDateTextExpired {
      color: ${({ theme }) => theme.colors.danger.danger};
    }
  }

  .cardTags {
    display: flex;
    align-items: center;
    padding-top: 12px;

    .cardTagVisibility {
      display: flex;
      align-items: center;
    }

    .cardTagPriority {
      display: flex;
      align-items: center;
      padding-left: 12px;
    }

    .cardTagText {
      font-size: 12px;
      line-height: 16.34px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      padding-left: 2px;
    }
  }
`;

export const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 9.5px;
  margin-left: 12px;
  background-color: ${({ theme }) => theme.colors.notification.notification};
`;
